import React from 'react';
import PropTypes from 'prop-types';
import { keys } from 'lodash';
import InfoViewComponent from './../Components/InfoViewComponent.jsx';
import { customPrioritySort } from './../helpers/utils';
import { metricsOrder } from './../../src/helpers/metrics';

export default class JobMetricsInfoComponent extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    metrics: PropTypes.object.isRequired,
    displayAllMetrics: PropTypes.bool
  };

  sortMetricsByKey(metrics) {
    const sortedKeys = customPrioritySort(metricsOrder, keys(metrics));
    const toReturn = {};
    for (const key in sortedKeys) {
      toReturn[sortedKeys[key]] = metrics[sortedKeys[key]];
    }
    return toReturn;
  }

  render() {
    const {
      title,
      metrics,
      displayAllMetrics
    } = this.props;
    let metricsView = null;

    const metricsTitle = title.indexOf('No Build Tag') === -1 ?
      'Metrics: ' + title : title;

    if (keys(metrics).length !== 0 ) {
      metricsView =
        <InfoViewComponent
          title={metricsTitle}
          items={this.sortMetricsByKey(metrics)}
          showWide={displayAllMetrics}
        />;
    }

    return (
      <div>
        {metricsView}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// src/Components/JobMetricsInfoComponent.jsx